import { Link } from "react-router-dom";
import { MapPin, Phone, Briefcase, BadgeCheck } from "lucide-react";

export const ProfessionalCard = ({ p }) => (
  <Link
    to={`/profissional/${p.id}`}
    data-testid={`professional-card-${p.id}`}
    className="bg-white rounded-2xl border border-[#e7e5e4] shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col"
  >
    <div className="p-6 flex items-start gap-4">
      <div className="w-16 h-16 rounded-2xl bg-[#e8f0ec] overflow-hidden flex items-center justify-center shrink-0">
        {p.photo_url ? (
          <img src={p.photo_url} alt={p.name} className="w-full h-full object-cover" />
        ) : (
          <span className="font-head text-2xl font-bold text-[#1b5e3f]">{(p.name || "?")[0]}</span>
        )}
      </div>
      <div className="min-w-0">
        <h3 className="font-head font-semibold text-[#1c1917] truncate flex items-center gap-1">
          {p.name}
          {p.verified && <BadgeCheck data-testid={`verified-tick-${p.id}`} className="w-4 h-4 text-[#2563eb] shrink-0" title="Perfil verificado" />}
        </h3>
        <div className="flex items-center gap-1 text-sm text-[#78716c] mt-1">
          <MapPin className="w-3.5 h-3.5" /> {p.city}, {p.region}
        </div>
      </div>
    </div>
    <div className="px-6 pb-6 flex-1 flex flex-col">
      <div className="flex flex-wrap gap-2 mb-3">
        <span className="bg-[#e8f0ec] text-[#1b5e3f] px-3 py-1 rounded-full text-xs font-semibold inline-flex items-center gap-1">
          <Briefcase className="w-3 h-3" /> {p.sector}
        </span>
      </div>
      <p className="text-sm text-[#78716c] line-clamp-2 flex-1">{p.bio || "Profissional disponível para oferecer serviços."}</p>
      <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#f59e0b]">Ver perfil →</span>
    </div>
  </Link>
);

export const RentalCard = ({ r }) => (
  <Link
    to={`/alugueis/${r.id}`}
    data-testid={`rental-card-${r.id}`}
    className="bg-white rounded-2xl border border-[#e7e5e4] shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col"
  >
    <div className="aspect-[16/10] bg-[#e8f0ec] overflow-hidden">
      {r.photos?.[0] ? (
        <img src={r.photos[0]} alt={r.title} className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-[#1b5e3f]/40 font-head">Sem foto</div>
      )}
    </div>
    <div className="p-5 flex-1 flex flex-col">
      <div className="flex items-center justify-between">
        <span className="font-head text-xl font-bold text-[#1b5e3f]">€{Number(r.price).toLocaleString("pt-PT")}<span className="text-sm font-normal text-[#78716c]">/mês</span></span>
        <span className="bg-[#fef3c7] text-[#d97706] px-3 py-1 rounded-full text-xs font-semibold">{r.type}</span>
      </div>
      <h3 className="font-head font-semibold text-[#1c1917] mt-2 line-clamp-1">{r.title}</h3>
      <div className="flex items-center gap-1 text-sm text-[#78716c] mt-1">
        <MapPin className="w-3.5 h-3.5" /> {r.city}, {r.region}
      </div>
      <div className="flex items-center gap-4 text-sm text-[#78716c] mt-3 pt-3 border-t border-[#e7e5e4]">
        <span>{r.bedrooms} quarto(s)</span>
        <span>{r.bathrooms} WC</span>
        {r.area ? <span>{r.area} m²</span> : null}
      </div>
    </div>
  </Link>
);
